import React, { useEffect, useRef, useState } from "react";
import applyleave from "./assets/applyleave.png";
import attendance from "./assets/attendance.png";
import Keyboard from "./assets/keyboard.png";
import raiserequest from "./assets/raiserequest.png";
import background from "./assets/background.png";
import plane from "./assets/plane.png";
import payslip from "./assets/payslip.png";
import ticket from "./assets/ticket.png";
import money from "./assets/money.png";
import profile from "./assets/profile.png";
import pic from "./assets/pic.jpg";
import add from "./assets/add.png";
import { ArrowRight, Computer, MapPin, TriangleAlertIcon, Utensils, UtensilsCrossed, X } from "lucide-react";
import {
  getAttendance,
  getDashboardData,
  getLeaveDetails,
  postBreakIn,
  postBreakOut,
  postCheckIn,
  postCheckOut,
} from "../../ApiHelper/url_Helpers";
import { useNavigate } from "react-router-dom";
import { FaSignInAlt, FaSignOutAlt } from "react-icons/fa";
import { toasterSuccess, toasterWarning } from "../../Components/toaster";
import ApplyLeaveModal from "../Attendance/ApplyLeave";
import Loader from "../../Components/Loader";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import {
  getCheckInReminderMessage,
  getWorkingDuration,
  shouldShowCheckInPopup,
} from "./DashboardData";
import HoverPopup from "../../Components/WarningModal";
import WarningModal from "../../Components/WarningModal";
dayjs.extend(duration);

const features_md = [
  { name: "Apply Leave", icon: applyleave },
  {
    name: "Raise  Request",
    icon: raiserequest,
    path: "/help-desk",
    state: true,
  },
  { name: "View Payslip", icon: Keyboard, path: "/payslips" },
  { name: "View Attendance", icon: attendance, path: "/attendance" },
];

export const Dashboard = () => {
  const fetchedRef = useRef();
  const navigate = useNavigate();
  const [ticketStatus, setticketStatus] = useState("All Tickets");
  const [workLocation, setWorkLocation] = useState("Office");
  const [tickets, setTicketsData] = useState();
  const [loading, setLoading] = useState(false);
  const [isCheck, setIsCheck] = useState("");
  const [open, setOpen] = useState(false);
  const [isApply, setIsApply] = useState("");
  const [isBreak, setIsBreak] = useState("");
  const [liveTimer, setLiveTimer] = useState("00:00:00");
  const [isAction, setIsAction] = useState();
  const reminderMsg = getCheckInReminderMessage(isAction?.check_in);
  const [showPopup, setShowPopup] = useState(false);
  const shiftTimings = tickets?.today_shift_timing || tickets?.shift
  const Work_Location = tickets?.location?.work_location || " ";


  const isToday = (createdAt) => {
    const date = new Date(createdAt);
    const now = new Date();

    return date.toDateString() === now.toDateString() ? true : false;
  };



  const fetchLeaveBalances = async () => {
    try {
      setLoading(true);
      const res = await getLeaveDetails();
      localStorage?.setItem("leaveType", JSON.stringify(res?.data?.leave_options || []));
    } finally {
      setLoading(false);
    }
  };

  const getTicketsApi = async () => {
    try {
      setLoading(true);
      const listResponse = await getDashboardData();
      fetchLeaveBalances();
      if (listResponse) {
        setTicketsData(listResponse);
        setIsCheck(
          listResponse?.action?.isCheck_in
            ? listResponse?.action?.isCheck_in
            : listResponse?.action?.isCheck_out
              ? false
              : false,
        );
        setIsBreak(listResponse?.action?.break === "on_break");
        setIsAction(listResponse?.action);
        setShowPopup(listResponse?.action?.show_checkin_reminder || false);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getTicketsByStatus = () => {
    if (ticketStatus === "In Progress") {
      return tickets?.tickets?.in_progress || [];
    }

    if (ticketStatus === "Completed") {
      return tickets?.tickets?.completed || [];
    }

    return tickets?.tickets?.all_tickets || [];
  };

  const handleCheck = async (check = false) => {
    try {
      let apiAction = check ? postCheckIn : postCheckOut;
      setLoading(true);
      const response = await apiAction();
      getTicketsApi();
      toasterSuccess(response?.message);
    } catch (err) {
      console.error(err);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleBreak = async (leave = false) => {
    try {
      setLoading(true);
      let apiAction = leave ? postBreakIn : postBreakOut;
      const response = await apiAction();
      getTicketsApi();
      toasterSuccess(response?.message);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    getTicketsApi();
  }, []);

  // Live working duration timer
  useEffect(() => {
    if (!isAction?.check_in || isAction?.check_out) return;
    const update = () => {
      setLiveTimer(getWorkingDuration(isAction.check_in));
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [isAction?.check_in, isAction?.check_out]);

  const filteredTickets = getTicketsByStatus();
  const onClickCard = (feature) => {
    if (feature?.name === "Apply Leave") {
      setOpen(true);
    }
  };

  const tabClass = "pb-1 text-sm transition-all";
  const activeClass =
    "border-b-2 border-[#00B8D9] font-semibold text-black text-[16px]";
  const inactiveClass = "text-gray-500 text-[16px] font-semibold";
  const hasTodayAnnouncement = tickets?.short_announcements?.some(
    ({ created_at }) => isToday(created_at)
  );

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className=" ">
          {showPopup && (
            <WarningModal
              open={showPopup}
              title="Check-in Required"
              message="You have not checked in yet."
              subMessage="Please check in to start your workday."
              confirmText="Check In Now"
              cancelText="Later"
              onCancel={() => setShowPopup(false)}
              onConfirm={() => {
                handleCheck(true);
                setShowPopup(false);
              }}
            />
          )}
          <div className="relative  p-4 md:p-8 bg-gradient-to-r from-[#E6F8FB4D] to-[#FFFFFF] w-full">
            <img
              src={background}
              className="absolute -pr-5 right-0 top-1/2 -translate-y-1/2 w-[180px] sm:w-[220px] md:w-[280px] opacity-80 pointer-events-none"
            />

            <div className="relative z-10 mb-6">
              <span className="text-lg font-semibold flex items-center gap-2">
                <span>👋</span> Good Morning,{" "}
                {tickets?.profile?.employee_name || " "}
              </span>
              <p className="text-gray-600 text-sm">
                Here's what's happening in your Workspace today.
              </p>
            </div>
            <div className="flex items-start relative z-10  w-full max-w-4xl sm:grid-cols-3 md:grid-cols-4 gap-3">
              {features_md?.map((item, i) => {
                const IconSrc = item.icon;
                return (
                  <div
                    key={i}
                    role="button"
                    className="bg-white border border-gray-100 shadow-sm rounded-lg flex flex-col gap-3 w-full max-w-[212px] h-[90px] p-[16px] cursor-pointer hover:shadow-md transition-all duration-200"
                    onClick={() => {
                      if (item.name === "Apply Leave") {
                        onClickCard(item);
                      } else {
                        navigate(item.path, { state: item.state });
                      }
                    }}
                  >
                    <img
                      src={IconSrc}
                      alt={item.name}
                      className="w-[21px] h-[24px] object-contain"
                    />
                    <p className="text-[14px]  text-[#4A4A4A]">{item.name}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="grid grid-cols-1 -ml-4 md:grid-cols-2 gap-4 px-2 pb-10 ml-6">
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 w-full">
              <span className="text-md font-semibold mb-4">
                Daily Attendance
              </span>
              <hr className="mt-2 mb-4" />
              <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                {/* LEFT SIDE */}
                <div>
                  <p className="py-1 text-sm text-gray-500">
                    Shift Timing  :   {shiftTimings?.scheduled_start_time?.slice(0, 5) ?? shiftTimings?.start_time} -{" "}
                    {shiftTimings?.scheduled_end_time?.slice(0, 5) ?? shiftTimings?.end_time}
                  </p>
                  <span className="font-bold text-xl">
                    {isAction?.check_out
                      ? isAction?.working_duration
                      : liveTimer || "00:00:00"}
                  </span>
                  <p className="text-gray-500 text-sm">Hours Logged Today</p>

                  {/* Check-in / Check-out */}
                  <div className="mt-4 text-sm space-y-1">
                    <p>
                      <span className="text-gray-500">Check In : </span>
                      <span className="font-medium">
                        {isAction?.check_in
                          ? dayjs(isAction.check_in).format("hh:mm A")
                          : "--"}
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500">Check Out : </span>
                      <span className="font-medium">
                        {isAction?.check_out
                          ? dayjs(isAction.check_out).format("hh:mm A")
                          : "--"}
                      </span>
                    </p>
                  </div>
                  {/* Break */}
                  <div className="mt-4 text-sm space-y-1">
                    <p>
                      <span className="text-gray-500">Break Start : </span>
                      <span className="font-medium">
                        {tickets?.latest_break_session?.start
                          ? dayjs(tickets?.latest_break_session?.start).format("hh:mm A")
                          : "--"}
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500">Break End : </span>
                      <span className="font-medium">
                        {tickets?.latest_break_session?.end
                          ? dayjs(tickets?.latest_break_session?.end).format("hh:mm A")
                          : "--"}
                      </span>
                    </p>
                    <p>
                      <span className="text-gray-500">Break Duration : </span>
                      <span className="font-medium">
                        {tickets?.latest_break_session?.end
                          ? tickets?.latest_break_session?.duration
                          : "00:00:00"}
                      </span>
                    </p>
                  </div>
                  <div className="mt-4">
                    <p className="text-md text-gray-500">Work Mode</p>
                    <p className="flex text-sm items-center gap-2 text-gray-600 py-2">
                      <Computer size={18} /> <span >{tickets?.attendance?.work_mode || "Remote"} </span>
                    </p>
                  </div><div className="mt-4">
                    <p className="text-md text-gray-500">Work Location</p>
                    <p className="flex text-sm items-center gap-2 text-gray-600 py-2">
                      <MapPin size={18} /> <span >{Work_Location?.name}{" "},{" "}{Work_Location?.city}{" "},{" "} {Work_Location?.state} </span>
                    </p>
                  </div>
                </div>

                {/* RIGHT SIDE BUTTONS */}
                <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                  {/* Break Button */}
                  <button
                    className="bg-cyan-500 hover:bg-cyan-600 text-white font-medium py-2 px-4 rounded-md shadow-md flex items-center justify-center gap-2"
                    onClick={() =>
                      !isBreak && !isAction?.check_out
                        ? handleBreak(true)
                        : handleBreak(false)
                    }
                    disabled={isAction?.check_out}
                  >
                    {!isBreak ? (
                      <Utensils className="w-4 h-4" />
                    ) : (
                      <UtensilsCrossed className="w-4 h-4" />
                    )}

                    <span className="text-sm">
                      {isBreak ? "Break End" : "Break Start"}
                    </span>
                  </button>

                  {/* Check In / Out Button */}
                  <button
                    className="bg-cyan-500 hover:bg-cyan-600 text-white font-medium py-2 px-4 rounded-md shadow-md flex items-center justify-center gap-2"
                    onClick={() =>
                      isCheck ? handleCheck(false) : handleCheck(true)
                    }
                  >
                    {isCheck ? (
                      <FaSignOutAlt className="w-4 h-4" />
                    ) : (
                      <FaSignInAlt className="w-4 h-4" />
                    )}

                    <span className="text-sm">
                      {isCheck ? "Check Out" : "Check In"}
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 w-full">
              <div className="flex justify-between">
                <span className="text-md font-semibold ">Short  Announcements</span>
                <p
                  className="flex justify-center items-center gap-1 text-[14px] text-gray-600 hover:text-[#00B8D9] cursor-pointer transition-colors duration-200"
                  onClick={() => navigate("/engage")}
                >
                  View all
                  <span>
                    <ArrowRight size={20} />
                  </span>
                </p>
              </div>
              <hr className="mt-2" />
              <div className="flex flex-col gap-2 mt-3">
                {tickets?.short_announcements?.map((item, index) => {

                  return (
                    isToday(item?.created_at) &&
                  <div key={index} className="flex flex-row items-center gap-4 py-1 border-b border-gray-100 last:border-b-0">
                    <div className="bg-primary text-white rounded-2xl flex items-center justify-center font-bold shadow-premium border-2 border-white transition-transform hover:rotate-3 active:scale-90 overflow-hidden w-16 h-16 flex-shrink-0">
                      <img
                        src={item?.attachment || "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&h=100&fit=crop"}
                        alt="avatar"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex flex-col justify-center">
                      <p className="text-black-600 font-semibold text-[16px] cursor-pointer hover:text-[#00B8D9] transition-colors text-ellipsis whitespace-wrap" role="button" onClick={() => navigate("/engage")}>
                        {item.title}
                      </p>
                      <p className="text-gray-500 text-[14px] mt-0.5 text-ellipsis whitespace-wrap">{item.group_name}</p>
                    </div>
                  </div>
                  )
                })}
                {!tickets?.short_announcements?.length > 0 || !hasTodayAnnouncement && (
                  <div className="flex items-center justify-center mt-5 gap-[28px] text-[14px]">
                    <p className="text-gray-500 ">No Data Available</p>
                  </div>
                )}
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 w-full">
              <div className="flex justify-between">
                <span className="text-sm font-semibold">My Tickets</span>
                <p
                  className="flex justify-center items-center gap-1 text-[14px] text-gray-600 hover:text-[#00B8D9] cursor-pointer transition-colors duration-200"
                  onClick={() => navigate("/help-desk")}
                >
                  View all
                  <span>
                    <ArrowRight size={20} />
                  </span>
                </p>
              </div>

              <hr className="mt-2" />

              {/* Tabs */}
              <div className="flex gap-4 py-3 overflow-x-auto mt-2">
                <button
                  onClick={() => setticketStatus("All Tickets")}
                  className={`${tabClass} ${ticketStatus === "All Tickets" ? activeClass : inactiveClass}`}
                >
                  All Tickets
                </button>

                <button
                  onClick={() => setticketStatus("In Progress")}
                  className={`${tabClass} ${ticketStatus === "In Progress" ? activeClass : inactiveClass}`}
                >
                  In Progress
                </button>

                <button
                  onClick={() => setticketStatus("Completed")}
                  className={`${tabClass} ${ticketStatus === "Completed" ? activeClass : inactiveClass}`}
                >
                  Completed
                </button>
              </div>

              {/* Tickets List */}
              <div className="space-y-2">
                {/* Header */}
                <div className="flex justify-between text-sm font-semibold text-gray-600 border-b pb-2">
                  <p className="w-1/3">Ticket ID</p>
                  <p className="w-1/3 text-center">Status</p>
                  <p className="w-1/3 text-right">Date</p>
                </div>

                {/* Rows */}
                {filteredTickets?.length > 0 ? (
                  filteredTickets.map((item, index) => (
                    <div
                      key={index}
                      className="flex justify-between text-sm border-b last:border-b-0 py-2"
                    >
                      <p className="w-1/3 text-gray-500  text-mute font-medium">
                        {item.ticket_id}
                      </p>

                      <p className="w-1/3 text-center text-gray-500 capitalize font-medium">
                        {item.status}
                      </p>

                      <p className="w-1/3 text-right text-gray-500 font-medium">
                        {item.created_at}
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-gray-400 text-sm py-6 font-medium">
                    No tickets found
                  </p>
                )}
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 w-full">
              <span className="text-md font-semibold mb-4 text-gray-900">
                Upcoming Holidays
              </span>
              <hr className="mt-2" />
              <div className="flex flex-col gap-3 mt-3">
                {tickets?.upcoming_holidays?.map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-row items-center gap-[28px] text-[14px]"
                  >
                    <p className="text-gray-500 ">
                      <span className="me-3">{item.date}</span> -
                    </p>
                    <p className="text-gray-500">{item.name}</p>
                  </div>
                ))}
              </div>
              {!tickets?.upcoming_holidays.name > 0 && (
                <div className="flex items-center justify-center mt-5 gap-[28px] text-[14px]">
                  <p className="text-gray-500 ">No Data Available</p>
                </div>
              )}
            </div>

            <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 w-full">
              <span className="text-md font-semibold mb-4">
                Upcoming Birthdays
              </span>
              <hr className="mt-2" />

              <div className="flex flex-col gap-2 mt-3">
                {tickets?.upcoming_birthdays?.map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-row items-center gap-[28px] text-[14px] "
                  >
                    <p className="text-gray-500">
                      <span className="me-3">{item.date_of_birth}</span> -
                    </p>
                    <p className="text-gray-500">{item.name}</p>
                  </div>
                ))}
              </div>
              {!tickets?.upcoming_birthdays.length > 0 && (
                <div className="flex items-center justify-center mt-5 gap-[28px] text-[14px]">
                  <p className="text-gray-500 ">No Data Available</p>
                </div>
              )}
            </div>

          </div>
          {open && (
            <ApplyLeaveModal
              open={open}
              onClose={() => setOpen(false)}
              setIsApply={setIsApply}
            />
          )}
        </div>
      )}
    </>
  );
};
